import React from 'react';
import { ReactComponent as Lock } from 'src/assets/images/iconsMvpApp/Unlocked.svg';
import { t } from 'i18next';

export const LockIcon = ({ className }: { className?: string }) => {
  const lockTitle = t('Logout');
  return (
    <Lock
      title={lockTitle}
      className={className}
      aria-label={lockTitle}
      style={{
        width: '24px',
        height: '24px',
      }}
    />
  );
};
